<template>
  <div>
    <Card shadow>
      <Drawer
        :title="changeModalTitle"
        v-model="changeModal"
        width="550"
        :mask-closable="true">
        <Form :model="changeForm" ref="changeForm" :rules="changeRule" :label-width="90" label-position="right">
          <FormItem prop="name" label="名称">
            <Input v-model="changeForm.name"/>
          </FormItem>
          <FormItem prop="disk_format" label="镜像格式">
            <Select v-model="changeForm.disk_format" :disabled="!isCreateForm" clearable placeholder="">
              <Option v-for="item in imageFormatList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="image_file_id" label="镜像文件" v-show="isCreateForm">
            <Upload
              type="drag"
              ref="uploadImage"
              :before-upload="beforeUploadImage"
              :on-success="uploadImageSuccess"
              :on-error="uploadImageError"
              :on-remove="ImageFileRemove"
              :with-credentials="true"
              :headers="uploadImageHeader"
              :action="privateCloudUploadImageUrl">
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="40" style="color: #3399ff"></Icon>
                <p>单击或拖动镜像文件到此区域</p>
              </div>
            </Upload>
          </FormItem>
          <FormItem prop="min_disk" label="最小磁盘要求">
            <InputNumber :min="0" v-model="changeForm.min_disk" style="width:85%"></InputNumber><span> (GB)</span>
          </FormItem>
          <FormItem prop="min_ram" label="最低内存要求">
            <InputNumber :min="0" v-model="changeForm.min_ram" style="width:85%"></InputNumber><span> (MB)</span>
          </FormItem>
          <FormItem prop="visibility" label="可见性">
            <RadioGroup v-model="changeForm.visibility" type="button">
              <Radio label="public">公有</Radio>
              <Radio label="private">私有</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="protected" label="受保护的">
            <i-switch v-model="changeForm.protected">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
            <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
          </FormItem>
        </Form>
      </Drawer>
      <Row>
        <AllTenantSwitch ref="AllTenantSwitch" v-on:callback="getImageData()" style="float: left;"></AllTenantSwitch>
        <Col style="float: left;">
          <Form ref="searchForm" inline :model="searchForm" :label-width="65">
            <FormItem label="镜像名称">
              <Input v-model="searchForm.name" style="min-width: 150px;" />
            </FormItem>
            <FormItem label="可见性" :label-width="55">
              <Select v-model="searchForm.visibility" style="min-width:100px" clearable placeholder="">
                <Option value="public" key="public">公有</Option>
                <Option value="private" key="private">私有</Option>
                <Option value="community" key="community">社区</Option>
                <Option value="shared" key="shared">共享</Option>
              </Select>
            </FormItem>
            <FormItem label="受保护的">
              <Select v-model="searchForm.protected" style="min-width:100px" clearable placeholder="">
                <Option value="True" key="True">是</Option>
                <Option value="False" key="False">否</Option>
              </Select>
            </FormItem>
            <FormItem label="镜像格式">
              <Select v-model="searchForm.disk_format" style="min-width:150px" clearable placeholder="">
                <Option v-for="item in imageFormatList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <!--<FormItem label="状态" :label-width="40">-->
              <!--<Select v-model="searchForm.status" style="width:150px" clearable placeholder="">-->
                <!--<Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
              <!--</Select>-->
            <!--</FormItem>-->
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getImageData()">搜索</Button>
              <Button @click="searchFormReset" style="margin-left: 10px">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col style="float: right;">
          <div style="float: right;">
            <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getImageData(image.page)">刷新</Button>
            <Button
              @click="formReset('changeForm'); changeModal = true; changeModalTitle = '创建镜像'; isCreateForm = true; $refs.uploadImage.fileList=[]"
              type="primary"
              :style="{marginBottom: '10px',marginLeft: '10px'}"
              icon="md-add">创建镜像</Button>
            <!--<Button-->
              <!--type="error"-->
              <!--:disabled="deleteImageBtnDisabled"-->
              <!--:style="{marginBottom: '10px', marginLeft: '10px'}"-->
              <!--icon="md-trash">删除镜像</Button>-->
          </div>
        </Col>
      </Row>
      <Table
        highlight-row
        :loading="tableLoading"
        @on-selection-change="imageTableSelect"
        ref="table"
        :data="image.data"
        :columns="image.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ image.data.length }} 条记录，总共 {{ image.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="image.count"
            :current="searchForm.page"
            :page-size="searchForm.size"
            @on-change="getImageData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudImage, changePrivateCloudImage, privateCloudUploadImageUrl, deletePrivateCloudImage,
  deletePrivateCloudImageFile } from '@/api/private-cloud/image'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import AllTenantSwitch from '@/view/private-cloud/components/allTenantSwitch'
import store from '@/store'
import moment from 'moment'

export default {
  components: {
    AllTenantSwitch,
    moment
  },
  data () {
    return {
      tableLoading: false,
      image: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '租户',
            minWidth: 130,
            align: 'center',
            key: 'owner',
            render: (h, params) => {
              return h('span', resourceIdTransName('projects', params.row.owner))
            }
          },
          {
            title: '镜像名称',
            align: 'center',
            minWidth: 150,
            key: 'name'
          },
          {
            title: '镜像ID',
            align: 'center',
            minWidth: 282,
            key: 'id'
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              let status = params.row.status
              let color = status === 'queued' ? 'warning'
                : status === 'saving' ? 'warning'
                  : status === 'uploading' ? 'warning'
                    : status === 'importing' ? 'warning'
                      : status === 'deleted' ? 'error'
                        : status === 'pending_delete' ? 'error'
                          : status === 'deactivated' ? 'error'
                            : status === 'killed' ? 'error'
                              : status === 'active' ? 'success'
                                : 'warning'
              let text = status === 'queued' ? '队列中'
                : status === 'saving' ? '保存中'
                  : status === 'uploading' ? '上传中'
                    : status === 'importing' ? '导入中'
                      : status === 'deleted' ? '已删除'
                        : status === 'pending_delete' ? '待删除'
                          : status === 'deactivated' ? '停用'
                            : status === 'killed' ? '错误'
                              : status === 'active' ? '可用'
                                : status
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          {
            title: '可见性',
            align: 'center',
            minWidth: 80,
            key: 'visibility',
            render: (h, params) => {
              if (params.row.visibility === 'public') {
                return h('div', '公有')
              } else if (params.row.visibility === 'private') {
                return h('div', '私有')
              } else if (params.row.visibility === 'shared') {
                return h('div', '共享的')
              } else {
                return h('div', params.row.visibility)
              }
            }
          },
          {
            title: '受保护的',
            align: 'center',
            width: 90,
            key: 'protected',
            render: (h, params) => {
              if (params.row.protected === true) {
                return h('div', '是')
              } else if (params.row.protected === false) {
                return h('div', '否')
              } else {
                return ''
              }
            }
          },
          // {
          //   title: '磁盘格式',
          //   align: 'center',
          //   minWidth: 90,
          //   key: 'disk_format'
          // },
          {
            title: '大小',
            minWidth: 130,
            align: 'center',
            render: (h, params) => {
              const KB = 1024
              const MB = KB * 1024
              const GB = MB * 1024
              let size = params.row.size
              if (size) {
                if (size >= GB) {
                  size = (size / GB).toFixed(2) + ' GB'
                } else if (size >= MB) {
                  size = (size / MB).toFixed(2) + ' MB'
                } else if (size >= KB) {
                  size = (size / KB).toFixed(2) + ' KB'
                } else {
                  size = size + ' 字节'
                }
              }
              return h('span', size)
            }
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 180,
            key: 'created',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'image_detail',
                        params: {'id': params.row.id}
                      })
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.modifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: params.row.protected ? 'none' : 'inline-block'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0
      },
      statusList: [
        {value: 'ACTIVE', label: '运行中'},
        {value: 'SAVING', label: '保存中'},
        {value: 'DELETED', label: '删除'},
        {value: 'ERROR', label: '错误'},
        {value: 'UNKNOWN', label: '未知'}
      ],
      imageFormatList: [
        {value: 'iso', label: 'iso - 光盘镜像'},
        {value: 'qcow2', label: 'qcow2 - QEMU模拟器'},
        {value: 'raw', label: 'raw'},
        {value: 'vhdx', label: 'vhdx - 大型虚拟硬盘'},
        {value: 'vmdk', label: 'vmdk - Vmware虚拟机磁盘'},
        {value: 'vdi', label: 'vdi - VirtualBox虚拟磁盘镜像'},
        {value: 'ploop', label: 'ploop - Virtuozzo/并行环回磁盘'},
        {value: 'ami', label: 'ami - Amazon机器镜像'},
        {value: 'ari', label: 'ari - Amazon Ramdisk镜像'},
        {value: 'aki', label: 'aki - Amazon内核镜像'},
        {value: 'vhd', label: 'vhd - Vmware虚拟硬盘'}
      ],
      searchForm: {
        name: '',
        visibility: '',
        protected: '',
        disk_format: '',
        page: 1,
        size: 10
      },
      changeModalTitle: '创建镜像',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        id: '',
        name: '',
        disk_format: '',
        min_disk: 0,
        min_ram: 0,
        visibility: 'public',
        protected: false,
        image_file_id: ''
      },
      changeRule: {
        name: [
          { required: true, message: '镜像名称不能为空', trigger: 'blur' }
        ],
        disk_format: [
          { required: true, message: '请选择镜像格式', trigger: 'change' }
        ]
      },
      privateCloudUploadImageUrl: privateCloudUploadImageUrl,
      uploadImageHeader: {
        Authorization: 'OPS ' + store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      isCreateForm: true,
      imageFileId: '',
      imageTableSelection: [],
      deleteImageBtnDisabled: true
    }
  },
  mounted: function () {
    this.getImageData()
  },
  methods: {
    // 获取镜像列表数据
    getImageData (value = 1) {
      this.searchForm.page = value
      this.searchForm.all_tenants = this.$refs.AllTenantSwitch.allTenants()
      this.tableLoading = true
      getPrivateCloudImage(this.searchForm).then(res => {
        this.image.data = res.data.results
        this.image.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取镜像列表失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取镜像列表失败！'
          })
        }
      })
    },
    // 搜索表单重置
    searchFormReset () {
      this.searchForm = {
        name: '',
        visibility: '',
        protected: '',
        disk_format: '',
        status: ''
      }
    },
    // 通用表单重置
    formReset (name) {
      this.$refs[name].resetFields()
    },
    // 提交镜像编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          if (this.isCreateForm) {
            if (!this.changeForm.image_file_id) {
              this.$Notice.error({
                title: '请上传镜像文件！'
              })
              return false
            }
          }
          this.changeLoading = true
          changePrivateCloudImage(this.changeForm, this.changeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getImageData()
            this.formReset('changeForm')
            this.changeLoading = false
            this.changeModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    // 打开编辑表单
    modifyOpen (row) {
      this.formReset('changeForm')
      this.changeForm.id = row.id
      this.changeForm.name = row.name
      this.changeForm.disk_format = row.disk_format
      this.changeForm.min_disk = row.min_disk
      this.changeForm.min_ram = row.min_ram
      this.changeForm.visibility = row.visibility
      this.changeForm.protected = row.protected
      this.changeModalTitle = '[' + row.name + '] 编辑'
      this.isCreateForm = false
      this.changeModal = true
    },
    // 删除单个镜像
    delete (row) {
      if (!row.protected) {
        deletePrivateCloudImage(row.id).then(res => {
          this.$Notice.success({title: '操作成功！'})
          this.getImageData()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！服务器无响应'
            })
          }
        })
      } else {
        this.$Notice.error({
          title: '该镜像是受保护的, 不能删除！'
        })
      }
    },
    // 上传镜像文件之前钩子
    beforeUploadImage () {
      const fileList = this.$refs.uploadImage.fileList
      if (fileList.length > 0) {
        this.$Notice.error({
          title: '只能上传一个镜像文件'
        })
        return false
      }
    },
    // 上传镜像文件成功
    uploadImageSuccess (res, file) {
      this.$Notice.success({
        title: '上传成功'
      })
      this.changeForm.image_file_id = res.id
    },
    // 上传镜像文件失败
    uploadImageError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 移除镜像文件
    ImageFileRemove (file) {
      deletePrivateCloudImageFile(this.changeForm.image_file_id)
      this.changeForm.image_file_id = ''
    },
    // 镜像列表选中项发生变化触发
    imageTableSelect (selection) {
      this.imageTableSelection = selection
      this.deleteImageBtnDisabled = !selection.length
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
